export const getAllLoginHistoryReducer = (state = { loading: true }, action) => {
  switch (action.type) {
    case 'GET_ALL_USERS_HISTORY_REQUEST':
      return {
        loading: true,
      };
    case 'GET_ALL_USERS_HISTORY_SUCCESS':
      return {
        loading: false,
        success: true,
        data: action.payload,
      };
    case 'GET_ALL_USERS_HISTORY_FAILED':
      return {
        loading: false,
        success: false,
        message: action.payload,
      };
    default:
      return state;
  }
};
